import { Helmet } from 'react-helmet-async';

export default function AppMeta() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://cdn.sanity.io" />
      <link rel="dns-prefetch" href="https://cdn.sanity.io" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,600;1,400&&display=swap" rel="stylesheet" />
      <link rel="shortcut icon" type="image/x-icon" href="data:image/x-icon;," />
      <link rel="shortcut icon" href="/images/icon-48x48.png" />
      <meta name="theme-color" content="#b8f0c0" />
      <link rel="apple-touch-icon" sizes="48x48" href="/images/icon-48x48.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/images/icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="96x96" href="/images/icon-96x96.png" />
      <link rel="icon" href="/images/favicon.ico" type="image/ico" sizes="16x16" />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/images/icon-180x180.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="192x192"
        href="/images/icon-192x192.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="512x512"
        href="/images/icon-512x512.png"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />

      <script
        type="text/javascript"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
                (function(a, h){
                    var botsRegexp = /aolbuild|baidu|bingbot|bingpreview|msnbot|duckduckgo|adsbot-google|googlebot|mediapartners-google|teoma|slurp|yandex/gi;
                    window.searchAgentOnPage = h && h==='#noquiz' || botsRegexp.test(a);
                })(navigator.userAgent, location.hash);
            `,
        }}
        id="botDetector"
      />
      <title>Credit Recovery</title>
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta name="description" content="Internal use only..." />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta property="og:site_name" content="depositobpr.id" />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};
